module.exports = __webpack_public_path__ + "img/导航栏右侧外.daae1461.png";